




















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceAvailabilityDisplay from '@ui/AudienceAvailability/AudienceAvailabilityDisplay'
import PricingTable from '@ui/Event/PricingTable'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'

settings =
  name: 'AudienceAvailabilityShow'

  resources:
    audience_availability:
      resourceName: 'audience_availability'
      slug: 'audience_availabilities/:audienceAvailabilityId'

  vue:
    components: {
      LoadingIndicator,
      AudienceAvailabilityDisplay,
      PricingTable,
      UpdatePricingModelTriggerModal,
    }

    computed:
      actionsForPricingModel: ->
        hiUpdatePricingModelTrigger: @hiUpdatePricingModelTrigger
        hiRemoveSpecialPricingTrigger: @hiRemoveSpecialPricingTrigger

    methods:
      hiTogglePublished: (published) ->
        payload = { audience_availability_id: @audience_availability.id }
        action = if published then 'publish' else 'unpublish'
        @triggerResource 'audience_availability', action, payload

      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire payloadOptions, modalOptions
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'audience_availability', 'update_pricing_model', { pricing_model: pricingModel }
      onAudienceAvailabilityUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()

export default VueOptions.vue settings
